import PropTypes from 'prop-types'

import Button from '../../../../shared_components/mui_base_components/button/Button'

import tfaAccountSecurityIllustration from '../../../assets/images/security.png'

import './tfaOnboardingPrompt.scss'

const TfaOnboardingPrompt = props => (
  <div className='tfa-onboarding-prompt'>
    <div className='tfa-onboarding-copy'>
      <div className='tfa-onboarding-header'>
        <h1 className='tfa-onboarding-title'>Let's secure your account</h1>
        <p className='tfa-onboarding-subtitle'>
          Add two-factor authentication for enhanced security.
        </p>
      </div>
      <div className='tfa-onboarding-callout-container'>
        <div className='tfa-onboarding-callout'>
          <p className='tfa-onboarding-callout-copy'>
            <strong>Why enable 2FA?</strong>
            {' '}
            Two-factor authentication adds an extra layer of security by requiring a second verification step when you sign in.
            You'll get a code on your phone or authenticator app each time you sign in, ensuring that only you can access your account.
          </p>
        </div>
        <div className='tfa-onboarding-callout tfa-onboarding-callout-secondary'>
          <p className='tfa-onboarding-list-title'>What you'll need:</p>
          <ul>
            <li className='tfa-onboarding-list-item'>Your mobile device</li>
            <li className='tfa-onboarding-list-item'>An Authenticator app (like Google Authenticator, Authy, or 1Password)</li>
            <li className='tfa-onboarding-list-item'>About 3-5 minutes to complete setup</li>
          </ul>
        </div>
      </div>
      <div className='tfa-onboarding-actions'>
        <Button className='tfa-onboarding-primary-btn' disabled={props.primaryDisabled} onClick={props.onPrimaryAction}>
          Secure my account
        </Button>
        {
          props.showSecondaryAction &&
          <button className='tfa-onboarding-secondary-btn' onClick={props.onSecondaryAction} type='button'>
            Do this later
          </button>
        }
      </div>
    </div>
    <div className='tfa-onboarding-illustration-wrapper'>
      <img
        alt='Illustration of a person sitting with a laptop in front of a lock and key'
        className='tfa-onboarding-illustration'
        src={tfaAccountSecurityIllustration}
      />
    </div>
  </div>
)

TfaOnboardingPrompt.propTypes = {
  onPrimaryAction: PropTypes.func,
  onSecondaryAction: PropTypes.func,
  primaryDisabled: PropTypes.bool,
  showSecondaryAction: PropTypes.bool
}

TfaOnboardingPrompt.defaultProps = {
  onPrimaryAction: null,
  onSecondaryAction: null,
  primaryDisabled: false,
  showSecondaryAction: true
}

export default TfaOnboardingPrompt
